(ns frontend.ui.page.lp-report-editor.step-7-published.view
  (:require
   [common.localization :as loc]
   [frontend.ui.page.lp-report-editor.common.event :as common-event]
   [frontend.ui.page.lp-report-editor.common.modal.pdf-preview-modal :as pdf-preview-modal]
   [frontend.ui.page.lp-report-editor.common.style :as common-style]
   [frontend.ui.page.lp-report-editor.common.view :as common-view
    :refer [continue-button
            footer next-button
            preview-pdf-button]]
   [frontend.ui.page.lp-report-editor.event :as editor-event]
   [frontend.ui.page.lp-report-editor.step-7-published.sub :as sub]
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]
   [herb.core :refer [<class]]
   [re-frame.core :as rf]
   [ui.components.button.view :as button]))

(defn step-footer
  [selected-report feeder?]
  (let [report @(rf/subscribe [::editor-sub/lp-report])
        full-access? @(rf/subscribe [::editor-sub/full-access?])]
    [footer
     {:left-content
      [:<>
       [continue-button]
       [:div
        [pdf-preview-modal/view
         {:on-close #(rf/dispatch [::common-event/close-pdf-preview])
          :report   selected-report
          :feeder?  feeder?}]
        [preview-pdf-button
         {:on-click #(rf/dispatch [::common-event/open-pdf-preview selected-report feeder?])}]]
       (when-let [burned-pdfs (seq (:lp-report/burned-pdfs selected-report))]
         [:div
          [button/secondary-hollow
           {:on-click #(rf/dispatch [::editor-event/open-burned-pdf burned-pdfs])}
           (loc/tr :open-burned-pdf)]])]
      ;; A report is archived only by a newer publish or by the fund page
      ;; action "Stop reporting permanently". For an archived report, this
      ;; step only links to the archived step.
      :right-content
      (when (and full-access?
                 (not= :lp-report.step/published (:lp-report/step report)))
        [:div
         {:class (<class common-style/spacing-left)}
         [next-button [::editor-event/activate-step :lp-report.step/archived]]])}]))

(defn published
  []
  [common-view/report-viewer sub/report-tab-path step-footer])


(defn body
  []
  [published])
